module.exports = __webpack_public_path__ + "static/img/15.4d40e46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/15.png
// module id = CYNL
// module chunks = 0